module.exports = __webpack_public_path__ + "static/sofola-643a5258f86c8827bbee2e0ee37973cb.jpg";